var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5761_11036)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5007 20L7.50065 16.25V11.9833L0.833984 4.48333V2.5C0.833984 1.83696 1.09738 1.20107 1.56622 0.732233C2.03506 0.263392 2.67094 0 3.33398 0L16.6673 0C17.3304 0 17.9662 0.263392 18.4351 0.732233C18.9039 1.20107 19.1673 1.83696 19.1673 2.5V4.48333L12.5007 11.9833V20ZM9.16732 15.4167L10.834 16.6667V11.35L17.5006 3.85V2.5C17.5006 2.27899 17.4129 2.06702 17.2566 1.91074C17.1003 1.75446 16.8883 1.66667 16.6673 1.66667H3.33398C3.11297 1.66667 2.90101 1.75446 2.74473 1.91074C2.58845 2.06702 2.50065 2.27899 2.50065 2.5V3.85L9.16732 11.35V15.4167Z",
    fill: ""
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5761_11036"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/filterIcon.ac6e9e0d94787f30906ad21b333f96b3.svg";
export { ForwardRef as ReactComponent };